import axios from 'axios';
import { newAbortSignal } from '../../utils';
import { SessionStore } from '../../types/store/SessionStore';
import { EmailLog, EmailLogsRequest } from '../../types/model/email';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/email/logs`;

export const getEmailLogs = async (params: EmailLogsRequest): Promise<EmailLog[]> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem('session') || '{}'
  );

  return await axios
    .get<EmailLog[]>(BASE_URL, {
      headers: {
        'content-type': 'application/json',
        'x-access-token': session?.accessToken,
      },
      params,
      timeout: parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        typeof AbortSignal.timeout !== 'undefined'
          ? AbortSignal.timeout(
              parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)
            )
          : newAbortSignal(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)),
    })
    .then((response) => response.data);
};
